import React, { useState, useEffect, useMemo } from 'react';
import './App.css';
import AuthUtils from './auth/auth_utils';
import AppRouter from './router/router';
import { ThemeProvider } from '@mui/material';
import { AuthProvider } from './auth/auth_context';
import getTheme from './layout/theme';
import EstablishPage from './auth/establish';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [mode, setMode] = useState('light');
  const isCallbackRoute = window.location.pathname === '/callback';
  const theme = useMemo(() => getTheme(mode), [mode]);

  useEffect(() => {
    if (!isCallbackRoute) {
      checkAuthentication();
    } else {
      setIsLoading(false);
    }
  }, [isCallbackRoute]);

  const checkAuthentication = () => {
    const sid = AuthUtils.GetAuthToken();
    if (sid) {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        {isAuthenticated || isCallbackRoute ? (
          <AppRouter />
        ) : (
          <EstablishPage />
        )}
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;



